(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-editorial-pilot"]) return;
  try {
    
document.querySelectorAll('.cf-editorial__navigation details').forEach((details) => {
  if (window.matchMedia('(max-width: 600px)').matches) details.open = false;
});

  } catch(e) { console.error(e); }
})();
})();
